export default __webpack_public_path__ + "static/media/finkit-html-markup.dbd72c8b.png";